import FingerprintJS from '@fingerprintjs/fingerprintjs';
import axios from "axios";
import { initializeApp } from 'firebase/app'
import { getMessaging,getToken,onMessage } from 'firebase/messaging'
import { mapMutations, mapActions, mapState,mapGetters } from "vuex";
const firebaseConfig = {
  apiKey: process.env.VUE_APP_apiKey,
  authDomain: process.env.VUE_APP_authDomain,
  databaseURL: process.env.VUE_APP_databaseURL,
  projectId: process.env.VUE_APP_projectId,
  storageBucket: process.env.VUE_APP_storageBucket,
  messagingSenderId: process.env.VUE_APP_messagingSenderId,
  appId: process.env.VUE_APP_appId,
  measurementId: process.env.VUE_APP_measurementId,
  fcmPublicVapidKey: process.env.VUE_APP_fcmPublicVapidKey,
  urlNotification: process.env.VUE_APP_urlNotification,
  serverkey: process.env.VUE_APP_serverkey,
};

const app = initializeApp(firebaseConfig);

const messaging = getMessaging();

const notificationMixin = {
    data() {
        return {
            userAuth: {},
            listenersStarted: false,
            permissionGranted: false,
            idToken: '',
        }
    },
    mounted() {
        this.userAuth = JSON.parse(localStorage.getItem("user"));
        console.log('created notificationMixin');
        this.startListeners();
        this.getPermissions();
        this.getIdToken();
    },
    computed: {
      ...mapGetters(["listNotifications","countNotifications",]),
   },
    methods: {
          ...mapMutations(["SET_NOTIFICATIONS","SET_NOTIFICATIONS_COUNT","SET_NOTIFICATION_MARK_AS_VIEWED"]),
          
          async getNotifications() {
            try {
              const { status, data } = await axios.get(
                `${process.env.VUE_APP_API_BOOKAPP}notifications/top`,
                {
                  headers: {
                    Authorization: localStorage.getItem("token_bookapp"),
                    conexion: localStorage.getItem("conexion"),
                  },
                }
              );
              if (status == 200) {
                this.SET_NOTIFICATIONS_COUNT(data.total);
                this.SET_NOTIFICATIONS(data.notifications);
              } else {
                console.log("error", data);
              }
            } catch (error) {
              console.log("error al obtener notificaciones: ", error);
              
            }
          },
          async getPermissions() {
            try {
              if (Notification.permission === 'granted') {
                this.notificationPermission = 'granted';
                console.log('Permiso para notificaciones ya concedido.');
                return true
              } else if (Notification.permission !== 'denied') {
                const permission = await Notification.requestPermission();
                this.notificationPermission = permission;
                if (permission === 'granted') {
                  return true;
                } else {
                  console.log('Permiso para notificaciones denegado.');
                  return false
                }
              } else {
                console.log('Permiso para notificaciones denegado previamente.');
                return false
              }
            } catch (error) {
              console.log(error);
              return false;
            }
          },
          async deviceInfo() {
            try {  
              const fp = await FingerprintJS.load();
              const result = await fp.get();
              const visitorId = await result.visitorId;
              const info = {
                visitorId: visitorId,
                userAgent: navigator.userAgent,
                platform: navigator.platform,
                language: navigator.language,
                deviceMemory: navigator.deviceMemory,
                hardwareConcurrency: navigator.hardwareConcurrency,
              };
              return info;
            } catch (error) {
              console.log(error);
            }
        },
        async getIdToken() {
            console.log('getToken');
            getToken(messaging, { vapidKey: process.env.VUE_APP_fcmPublicVapidKey })
            .then((token) => {
                this.saveToken(token);
            })
            .catch((error) => {
                console.error("Error getting token:", error);
            });
        },
        startListeners() {
            this.startOnMessageListener()
            //this.startTokenRefreshListener()
            this.listenersStarted = true
        },
        async startOnMessageListener() {
            console.log('startOnMessageListener');
            onMessage(messaging, (payload) => { 
                  const Toast = this.$swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                      toast.onmouseenter = Swal.stopTimer;
                      toast.onmouseleave = Swal.resumeTimer;
                    }
                  });
                  Toast.fire({ icon: "success",title: payload.notification.title,text: payload.notification.body,});
                  this.getNotifications();
            });
        },
        startTokenRefreshListener() {
            console.log('startTokenRefreshListener');
            messaging.onTokenRefresh(async () => {
              try {
                const refreshedToken = await messaging.getToken()
                this.idToken = refreshedToken
                this.saveToken(refreshedToken);
              } catch (e) {
                console.error('Unable to retrieve refreshed token ', e)
              }
            })
        },
        async saveToken(token) {


          try {
            let device = await this.deviceInfo();
            let dataSend = {
              "identifier": device.visitorId,
              "data": JSON.stringify([device]),
              "token": token,
              "user_id": this.userAuth.id,
              "status": "active"
            };

            const { status, data } = await axios.post(`${process.env.VUE_APP_API_BOOKAPP}devices`, dataSend,
              {
                headers: {
                  Authorization: localStorage.getItem("token_bookapp"),
                  conexion: localStorage.getItem("conexion"),
                },
              }
            );
            if (status == 200) {
              console.log('Token guardado correctamente');
              console.log(data);
            }else{
              console.log('Error al guardar el token');
              console.log(data);
            }
          } catch (error) {
            console.log(error);
            
          }                 
        }
    },
};

export default notificationMixin;
